<template>
	<div>
		<div class="treeTable">
			<!-- GERA MODAL PARA A TREEVIEW -->
			<b-modal id="modal-detalhes-dre"
				ref="modalDre"
				title="Detalhes do mês selecionado"
				size="lg"
				v-drag
				tabindex="-1">
				<template v-if="modalDetalhes && modalDetalhes.detalhes" style="position:relative;"><!-- VERIFICO SE EXISTEM DETALHES -->
					<span class="premium-tag-s" style="right: 44px;top: -42px;">
						<i class="far fa-star"></i>&nbsp;
						<b>Premium</b>
					</span>
					<!-- <detalhe-dre 
            :planoDeConta="modalDetalhes"
            :detalhes="localList"></detalhe-dre> -->

          <detalhe-dre :datas="modalDetalhes" :source="list"></detalhe-dre>
          
				</template>
				<template v-else>
					<p>Não existem detalhes para esse item.</p>
				</template>
				<template #modal-footer="{ hide }">
					<div class="float-right">
						<el-button size="small" @click="hide()">Fechar</el-button>
					</div>
				</template>
			</b-modal>
			<table class="table"><!-- TREEVIEW COM HEADER E 1COLUNA FIXAS -->
				<thead class="thead-dark">
					<tr>
						<th>
							<el-tooltip :content="!expandirTodos ? 'Expandir todos' : 'Recolher todos'" placement="top">
								<span class="expandir-todos" @click="clickExpandirRecolherTodos">
									<i class="fas" :class="!expandirTodos ? 'fa-plus' : 'fa-minus'"></i>
								</span>
							</el-tooltip>
							Nome
						</th>
						<template v-if='treeDataSource.length>0'>
							<th v-bind:key="i" v-for="(mes,i) in treeDataSource[0].meses" :class="`td${(i == 0 ? 1 : i)+1}`" style="width:200px">
								{{ mes.descricao }}
							</th>
						</template>
					</tr>
				</thead>
				<template v-if='treeDataSource.length>0'>
					<tbody>
						<tree-item
							v-for="(model,i) in treeDataSource"
							:key="'root_node_'+i"
							:root="0"
							:num="i"
							@handlerExpand="handlerExpand"
							:nodes="treeDataSource.length"
							:trees.sync="treeDataSource"
							:model.sync="model">
						</tree-item>
					</tbody>
				</template>
			</table>
		</div>
	</div>
</template>

<script>

const filterModel = () => {
    return {
		page: 1,
		pageSize: 10,
		competencia: "",
		sort: "",
		order: "",
		planoDeContasId: "",
		tipoDeValorDePDV: "",
		cmv: false,
		empresaId: "",
		linhaManualDaDREId: ""
	}
}

import { EventBusDRE } from '@/views/DRE/detalheDRE/eventBusDRE.js';
//import detalheDRE from '@/views/DRE/detalheDRE/DetalheDRE'
import detalheDRE from '@/views/DRE/DetalheDRE'

export default {
	name: 'treeTable',
	props: ['list'],
	data() {
		return {
            gerarRelatorioDetalhesVisivel: false,
            exportarDetalhesDisabled: false,
			treeDataSource: [],
			modalDetalhes: [],
			expandirTodos: false,
			filterDetalhes: filterModel(),
			detalhesResponse: { },
			loadingDetalhes: false,
      localList: [...this.list]
		}
	},
	watch: {
		'list': {
			handler(newList) {
        this.localList = [...newList];
				this.initTreeData()
				this.expandirTodos = false
			},
			deep: true
		},
		'filterDetalhes.empresaId': function() {
			this.pegarDetalhesDoBackend()
		}
	},
	methods: {
		initTreeData() { // ADD CONFIGURAÇÕES
			let tempData = JSON.parse(JSON.stringify(this.list))

			let reduceDataFunc = (data, level) => {
				data.map((m) => { // add opções a mais ao json
					m.isExpand = false
					m.level = level
					m.bLeft = level === 1 ? 34 : (level - 2) * 16 + 34
					if (m.filhos && m.filhos.length > 0) {
						reduceDataFunc(m.filhos, level + 1)
					}
				})
			}
			reduceDataFunc(tempData, 1)
			//this.treeDataSource = this.listToTree(tempData,'_id', 'Parent', '_id')
			this.treeDataSource = tempData
		},
		handlerExpand(m) { // ABRIR/FECHAR FILHO
			this.$emit('handlerExpand', m)
			this.expandirTodos = false
		},
    changeColor(val, color) { // VERIFICA VERMELHO/VERDE/CINZA PELO VALOR
      let style = '';

      if (val < 0) {
          style = color ? 'color:#f18989' : 'border-color:#f18989';
      } else if (val == null || val === '') {
          style = color ? 'color:#a2a0a0' : 'border-color:#a2a0a0';
      } else {
          style = color ? 'color:#58ce5b' : 'border-color:#58ce5b';
      }

      return style;
    },
		expandirRecolherTodos(data) {
      for (const item of data) {
          item.isExpand = this.expandirTodos;

          if (item.filhos) {
              this.expandirRecolherTodos(item.filhos);
          }
      }
    },
		clickExpandirRecolherTodos(){
			this.expandirTodos = !this.expandirTodos
			this.expandirRecolherTodos(this.treeDataSource)
		},
		pegarDetalhesLinha(value){
			this.filterDetalhes = filterModel();

			if (value.linhaDaDREId != null) {
				this.modalDetalhes = this.pegarDetalhesDeLinhasDaDRE(value.linhaDaDREId, value.descricao)
			}
			else {
				this.filterDetalhes.planoDeContasId = value.planoDeContasId
				this.filterDetalhes.tipoDeValorDePDV = value.tipoDeValorDePDV
				this.filterDetalhes.cmv = value.cmv
				this.filterDetalhes.competencia = value.descricao
				this.filterDetalhes.linhaManualDaDREId = value.linhaManualDaDREId
				this.pegarDetalhesDoBackend()
			}
		},
		pegarDetalhesDeLinhasDaDRE(linhaId, descricao) {
			var result = null;

			this.treeDataSource.forEach((value) =>{
				if (result != null)
					return;

				if (value.linhaDaDREId == linhaId){
					result = value.meses.find(t => t.descricao == descricao);
					return;
				}

				result = this.pegarDosFilhos(value, linhaId, descricao);
			});

			return result;
		},
		pegarDosFilhos(value, linhaId, descricao){
			var result = null;
			
			if (value.filhos == null || value.filhos == undefined || value.filhos.length == 0){
				return result;
			}

			value.filhos.forEach((filho)=>{
				if (result != null){
					return;
				}

				if (filho.linhaDaDREId == linhaId){
					result = filho.meses.find(t => t.descricao == descricao);
					return;
				}
				
				result = this.pegarDosFilhos(filho, linhaId, descricao)
			})

			return result;
		},
		async pegarDetalhesDoBackend() {
			const loading = this.$loading();

			try {
				const request = await this.axios.post(
					this.$urls.DRE_DETALHES_LINHA_DRE,
					Object.assign(this.filterDetalhes, { filter: this.dreFiltros })
				);

				if (request.status !== 200) {
					this.$message.error(
						'Algum erro interno aconteceu, por favor consulte nosso suporte.'
					);
					return;
				}

				this.detalhesResponse = request.data;
				this.$bvModal.show('modal-detalhes-linha');
			} catch (error) {
				console.error('Erro ao obter detalhes do backend:', error);
				this.$message.error('Ocorreu um erro ao obter os detalhes do backend.');
			} finally {
				loading.close();
			}
		},
		handleSizeChange(val) {
            this.filterDetalhes.pageSize = val
            this.filterDetalhes.page = 1
			this.pegarDetalhesDoBackend()
        },
        handleCurrentChange(val) {
            this.filterDetalhes.page = val
			this.pegarDetalhesDoBackend()
        },
		sortChange(val) {
			this.filterDetalhes.sort = val.prop
			this.filterDetalhes.order = val.order
			this.pegarDetalhesDoBackend()
		},
        exportarRelatorioDetalhes() {
            this.requestExportarRelatorio();
            this.gerarRelatorioDetalhesVisivel = false;
        },
		async requestExportarRelatorio() {
            let request = await this.axios.post(this.$urls.DRE_EXPORTAR_DETALHES_LINHA, this.filterDetalhes);

            if(request.status !== 200) {
                this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                return;
            }

            this.$notify({
                type: "success",
                title: 'Gerando Relatório',
                dangerouslyUseHTMLString: true,
                message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
            });

            this.exportarDetalhesDisabled = false;
        }
	},
	components: {
		'detalhe-dre': detalheDRE,
		treeItem: () => import('./shared/TreeItem.vue') // importa o treeitem para gerar uma funcao recursiva
	},
    computed: {
        totalDeRegistros(){
            return this.detalhesResponse.total
        },
		dreFiltros: {
            get() {
                return this.$store.state.dreFiltros;
            },
            set(value) {
                this.$store.commit('updateDREFiltros', value);
            }
        }
    },
	mounted() {
		const vm = this
		vm.$nextTick(() => {
			vm.initTreeData()
		})
		vm.$root.$on('modalDetalhes', (dt) => {
			this.modalDetalhes = dt
		})

		this.$root.$on('bv::show::modal', (bvEvent, modalId) => {
			document.querySelector('body').classList.add('modal-open')
		})
		this.$root.$on('bv::show::hide', (bvEvent, modalId) => {
			document.querySelector('body').classList.remove('modal-open')
		})
	},
  created() {
    // Escutando o evento para atualizar os dados do modal
    EventBusDRE.$on('atualizarModalDetalhes', (dados) => {

      // Força a reatividade criando um novo objeto
      this.modalDetalhes = { ...dados };
      this.localList = Array.isArray(dados.detalhes) ? [...dados.detalhes] : [];
      

      this.$nextTick(() => {
        console.log("modalDetalhes atualizado:", this.modalDetalhes);
        console.log("list atualizado:", this.list);
        
        this.$refs.modalDre.show();
      });
    });
  },
  beforeDestroy() {
    // Removendo o listener para evitar vazamento de memória
    EventBusDRE.$off('atualizarModalDetalhes');
  }
}
</script>
<style>
	body.modal-open {
		overflow: hidden !important;
	}
</style>
